// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header__2L3DO","contentBorder":"App_contentBorder__UvOWy","contentInner":"App_contentInner__1vbWV","footer":"App_footer__3csul"};